import types from '../types';

/**
 * @param {types.AdvancedFilter[]} filters
 * @param  {string} filterId
 * @returns {types.AdvancedFilter[]}
 */
const getAdvancedFiltersStateWithResetedSelect = (filters, filterId) => {
    if (!filters || !Array.isArray(filters) || !filters.length) {
        return [];
    }

    return filters.map(filter => {
        if (filter.id === filterId) {
            return {
                ...filter,
                value: null
            };
        }

        return filter;
    });
};

export default getAdvancedFiltersStateWithResetedSelect;
